<template>
  <ul v-if="filter.aggregations.length > 0 && filter.label !== ''"
      class="serp__filter-subitem q-list-group q-list-group-flush">
    <li class="serp__filter-subitem--element q-list-group-item" v-for="aggregate in filter.aggregations" :key="aggregate.label">
      <input class="serp__filter-subitem--input q-form-check-input q-me-2" type="checkbox" :value="field"
             @change="filtersStore.updateCategoryItem(field, aggregate.label)"
             :checked="filtersStore.filterIsChecked(field, aggregate.label)"
      >
      <FilterBadge :filter="aggregate"/>
      <SubCategoryItem v-if="aggregate.aggregations.length > 0 " :filter="aggregate" :field="field"/>
    </li>
  </ul>
</template>
<script setup lang="ts">
import {defineProps} from 'vue';
import FilterBadge from "@/components/SerpPage/FiltersContainer/FiltersList/FilterItem/FilterLabel.vue";

defineProps(['filter', 'field'])
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";

const filtersStore = useFiltersStore();

</script>
<style scoped>
input.serp__filter-subitem--input {
  cursor: pointer!important;
}
.q-form-check-input{
  width: 1.25em;
  height: 1.25em;
}

.q-form-check-input:checked {
  background-color: var(--q-red);
  border-color: var(--q-red);
}
.serp__filter-subitem--element{
  text-wrap: nowrap;
}
</style>